export default __webpack_public_path__ + "static/Tek_Ladder-e040dd37d5629971a5984eb189b24a2c.png";